import "@fontsource/roboto/latin-ext.css";
import "@fontsource/roboto/latin.css";
import { App as AntApp } from 'antd';
import { FC } from "react";
import { createRoot } from 'react-dom/client';
import { GLOB } from "src/util/Glob";
import { patchTableMeasurements } from "src/util/patchTableMeasurements";
import { onCLS, onINP, onLCP } from 'web-vitals';
import App from './App';
import './index.less';
import "./service/log.service";
import { ThemeProvider } from "./theme/ThemeProvider";

// Must run before any library captures a reference to
// Element.prototype.getBoundingClientRect or HTMLElement offsetWidth/Height.
// Keeps antd table header/body columns in sync and clamps small upward drift to
// break subpixel feedback loops at non-1.0 devicePixelRatio (browser zoom !=
// 100% or OS display scaling such as Windows 125% / 150%).
patchTableMeasurements();

onCLS(console.log);
onINP(console.log);
onLCP(console.log);

const AntAppHooks: FC = () => {
  GLOB.app = AntApp.useApp();
  return <></>;
};

createRoot(document.getElementById('root')).render(
  <ThemeProvider>
    <AntApp notification={{ top: 40 }}>
      <AntAppHooks />
      <App />
    </AntApp>
  </ThemeProvider>
);
